import { Component } from './component.types';

export enum SectionType {
  unknown = 'unknown',
  column = 'column',
  tabbed = 'tabbed',
}

export type BaseSection = {
  type: SectionType;
  title?: string;
};

export type SectionTab = {
  name: string;
  label: string;
  path: string;
};

export type TabbedSection = BaseSection & {
  tabs: SectionTab[];
  activeTab: string;
};

export enum SectionColumnWidth {
  full = 'full',
  half = 'half',
  '1/3' = '1/3',
  '2/3' = '2/3',
  '1/4' = '1/4',
  '3/4' = '3/4',
}

export type ColumnSectionColumn = {
  width: SectionColumnWidth;
  component: Component;
};

export type ColumnSection = BaseSection & {
  columns: ColumnSectionColumn[];
};

export type UnknownSection = BaseSection;

export type Section = TabbedSection | ColumnSection | UnknownSection;
